import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import StyledButton from "components/shared/StyledButton";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { IArticle } from "store/articleStore";
import { getAllArticles, getAllArticlesBeneficiars } from "store/articleStore";
import { fetchUpdateBeneficiaryPress } from "store/beneficiaryStore";
import type { ITerm } from "store/managementStore";
import { useAppDispatch } from "store/store";

interface IEmailModal {
    article: IArticle | ITerm | null;
    handleClose: () => void;
    beneficiaryId: number;
    /**
     * On press portal, from which page is launched the AgreementModal
     */
    pageType?: "publication" | "beneficiary" | "management";
}

interface EmailForm {
    email: string;
}

const EmailModal = ({ article, handleClose, beneficiaryId, pageType }: IEmailModal) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();

    const defaultValues: EmailForm = {
        email: "",
    };

    const { control, handleSubmit, watch } = useForm({ defaultValues });

    const email = watch("email").replace(/\s/g, "");

    const onSubmit = (data: EmailForm) => {
        const req = {
            email: data.email.replace(/\s/g, ""),
        };

        article &&
            dispatch(
                fetchUpdateBeneficiaryPress({
                    id: (article as IArticle).beneficiaryId,
                    data: req as any,
                }),
            ).then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    if (["publication", "management"].includes(pageType ?? "") && article.titleId != null)
                        dispatch(getAllArticles(article.titleId));
                    if (pageType === "beneficiary") dispatch(getAllArticlesBeneficiars(beneficiaryId));
                    handleClose();
                }
            });
    };

    return (
        <div className="email-form-container">
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <TextFormComponent
                    label={t("Agreements.EmailAdressBeneficiar")}
                    controlName="email"
                    control={control}
                    placeholder="exemple@exemple.com"
                />
                <StyledButton buttonType="primary" type="submit" disabled={!email}>
                    {t("Agreements.SaveEmail")}
                </StyledButton>
            </form>
        </div>
    );
};

export default EmailModal;
